import React from 'react';
import { Header } from '../IndexPage/Header/Header';
import { HerosectionsAll } from '../HeroSectionAll/HerosectionsAll';
import { Footer } from '../Footer/Footer';


export const OurTeam = () => {

    return (
        <>
<div className="container-fluid">
            <Header actives="OurTeam" subactive="About" />

            <HerosectionsAll ScreenName="Our Team" ScreenSearch="Consultancy" />

            <div className="row px-lg-5 my-lg-0   py-5 py-lg-5 bg_team" >

                <div className='row col-lg-10 mx-auto'>

                    <div className="col-12 my-4">
                        <div className="pt-5 pb-4 ps-5 bg_color3 rounded">
                            <h5 className="fw-bold pb-3"> A.W.J. (Tony) Fernandez. </h5>
                            <p> Risk Management Consultant, Consulting Average Adjuster & Learning Facilitator. </p>
                            <p> Chief Shipwright Artificer (Indian Navy-1965-1971). </p>
                            <p> Hon. Fellow International Institute of Marine Surveying (UK). </p>
                            <p> Maritime Operational Risk Management Advisor, Mediator & Arbitrator. </p>
                            <p> Associate Member Association of Average Adjusters of the United States & Canada. </p>
                            <p> Visiting Professor Maritime Law & Insurance Law - Gujarat National Law University. </p>
                            <p> Module Leader – PGD, Marine Insurance Law & Practice - World Maritime University, Sweden. </p>
                        </div>
                    </div>

                    <div className="col-12 my-4">
                        <div className="pt-5 pb-4 ps-5 bg_color3 rounded " >
                            <h5 className="fw-bold pb-3"> Mrs. Anuradha Prasad More. </h5>
                            <p> Senior Associate Member of the Association of Average Adjusters (UK)</p>
                            <p> Fellow member of Insurance Institute of India</p>
                            <p> Bachelor of Law Mumbai University</p>
                            <p> Ex-Underwriter, 25 years experience with United India Insurance Co.Ltd.</p>
                        </div>
                    </div>

                    {/* <div className="col-12 my-4">
                        <div className="pt-5 pb-4 ps-5 bg_color3 rounded " >
                            <h5 className="fw-bold pb-3"> Mrs. Anuradha Prasad More. </h5>
                            <p> Associate Member of Association of Average Adjuster- UK. </p>
                            <p> Member of Chartered Insurance Institute of London- Dip-CII. </p>
                            <p> Fellow Member of Insurance Institute of India- FIII. </p>
                            <p> M Com, Bachelor of Law (LL.B) - University of Mumbai. </p>
                            <p> Ex-Underwriter - 25 years at United India Insurance Company Ltd.(Govt. Undertaking ). </p>
                        </div>
                    </div> */}

                    <div className="col-12 my-4">
                        <div className="pt-5 pb-4 ps-5 bg_color3 rounded ">
                            <h5 className="fw-bold pb-3"> Miss. Gita R. Sakpal. </h5>
                            <p>Training Need Analysis (TNA) consultant.</p>
                            <p>Recognised Trainer (RT) of Government of India.</p>
                            <p>MSc in Industrial Psychology.</p>
                            <p>MA in Education.</p>
                            <p>Master of Social Work.</p>
                        </div>
                    </div>

                    <div className="col-12 my-4">
                        <div className="pt-5 pb-4 ps-5 bg_color3 rounded ">
                            <h5 className="fw-bold pb-3"> Mrs. Anjana P. Shelar. </h5>
                            <p>Cost and Management Accountant (CMA) </p>
                        </div>
                    </div>

                </div>

            </div>

            <Footer />
            </div>
        </>
    )
}
